import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import defaultImage from "assets/icons/image.svg";
import "./Image.css";

const Image = ({ src, alt, defaultSrc = defaultImage, className = "", size = "auto", circle = false, ...props }) => {
  const handleError = (e) => {
    if (e.target.src !== defaultSrc) {
      e.target.src = defaultSrc;
    }
  };

  const sizeClass = {
    "img-sm": size === "small",
    "img-md": size === "medium",
    "img-lg": size === "large",
    "img-xl": size === "xlarge",
  };

  const imageClasses = classNames("image", className, sizeClass, { "img-circle": circle });

  const style = {};
  if (typeof size === "string" && /^\d+(px|rem|em|%|vw|vh|vmin|vmax)$/.test(size)) {
    style.width = size;
    style.height = size;
  } else if (typeof size === "number") {
    style.width = `${size}px`;
    style.height = `${size}px`;
  }

  return <img src={src} alt={alt || "Image"} className={imageClasses} style={style} onError={handleError} {...props} />;
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  defaultSrc: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large", "xlarge", "auto"]), PropTypes.string, PropTypes.number]),
  circle: PropTypes.bool,
};

export default Image;
